<template>
    <el-dialog
        class="feedBack-box"
        title="错误反馈"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="772px"
        :before-close="handleClose">
        <div>
            <div
                v-for="(item, index) in newForm"
                class="row"
                :key="index"
            >
                <div
                    v-if="item.type === 'radio'"
                    class="txt">
                    <p class="name">{{item.name}}：</p>
                    <p class="value">
                        <el-checkbox v-model="question">题干</el-checkbox>
                        <el-checkbox v-model="answer">答案</el-checkbox>
                        <el-checkbox v-model="analyze">解析</el-checkbox>
                        <el-checkbox v-model="other">其他</el-checkbox>
                    </p>
                </div>
                <div
                    v-else-if="item.type === 'textarea'"
                    class="txt">
                    <p class="name">{{item.name}}：</p>
                    <el-input
                            class="textarea"
                            type="textarea"
                            rows="6"
                            placeholder="请输入纠错内容不能少于3个字。您的反馈对我们很重要，我们会尽快改进。"
                            v-model="item.value"
                            minLength="3"
                            maxlength="3000"
                            show-word-limit
                            @focus="setSendKeyBoardToCocos({key: 'textAreaValue', value: false})"
                            @blur="setSendKeyBoardToCocos({key: 'textAreaValue', value: true})"
                    />
                </div>
                <div
                    v-else
                    class="txt">
                    <p class="name">{{item.name}}：</p>
                    <p class="value">{{item.value}}</p>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </span>
    </el-dialog>
</template>

<script>
    import {mapActions} from 'vuex'
    import * as CommonServer from "../../api/common";

    export default {
        name: "feed-back",
        props: {
            form: Array,
            visible: {
                type: Boolean,
                default: true
            }
        },
        watch:{
            visible(vl){this.dialogVisible = vl},
            dialogVisible(vl){
                this.$emit('update:visible', vl)
            },
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form', vl)}
        },
        mounted() {
            this.$nextTick(()=>{
                this.init()
            })
        },
        data(){
            return {
                dialogVisible: this.visible,
                newForm: this.form,
                // 当前板块及课程状态集
                newMenusData: this.menusData,
                question: false,
                answer: false,
                analyze: false,
                other: false,
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos']),
            init(){
            },
            handleClose() {
                this.newForm[0].value = ''
                this.newForm[1].value = ''
                this.newForm[2].value = ''
                this.newForm[3].value = ''
                this.newForm[4].value = ''
                this.dialogVisible = false
            },
            async submit() {
                if(
                    !this.question &&
                    !this.answer &&
                    !this.analyze &&
                    !this.other
                ){
                    this.$message.warning('请至少选中一个"错误内容"')
                    return false
                }

                // 1.判断文本域
                let feedbackIndex = this.$utils.getIndexByAttr({attr: 'feedback', data: this.newForm})
                let feedback = this.newForm[feedbackIndex].value
                if(!feedback || feedback.length<3){
                    this.$message.warning('请输入至少3个字的错误反馈')
                    return false
                }
                const txt = feedback.replace(/( )/g,'');
                if(feedback && !txt){
                    this.$message.warning('纠错内容不能只输入空格')
                    return false
                }
                if(feedback && feedback.length>3000){
                    this.$message.warning('输入的错误反馈过长，文字不超过3000字')
                    return false
                }

                let questionIndex = this.$utils.getIndexByAttr({attr: 'question_id', data: this.newForm})
                let question_id = this.newForm[questionIndex].value

                let subjectIndex = this.$utils.getIndexByAttr({attr: 'subject_id', data: this.newForm})
                let subject_id = this.newForm[subjectIndex].subject_id
                let grade_id = this.newForm[subjectIndex].grade_id

                const res = await CommonServer.default.updateErrorReport({
                    question_id,
                    subject_id,
                    grade_id,
                    feedback,
                    question: this.question?1:0,
                    answer: this.answer?1:0,
                    analyze: this.analyze?1:0,
                    other: this.other?1:0
                })
                console.log('错误反馈==>', res)
                if(res && res.status_code === 200){
                    this.$message.success('提交成功')
                    this.handleClose()
                } else{
                    this.$message.error('提交失败')
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    .feedBack-box /deep/ .el-dialog__body{
        padding: 14px 20px;
    }
    .feedBack-box /deep/ .el-radio__input.is-checked .el-radio__inner {
        border-color: #e7622e;
        background: #e7622e;
    }
    .feedBack-box /deep/ .el-radio__input.is-checked+.el-radio__label {
        color: #e7622e;
    }
    .feedBack-box /deep/ .el-radio__label{
        padding-left: 6px;
    }
    .feedBack-box /deep/ .el-radio{
        margin-right: 24px;
    }
    .row{
        .txt {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            font-size: 14px;
            font-weight: 400;
            color: #303133;
            line-height: 36px;

            .name {
                width: 104px;
                text-align: right;
            }
            .textarea{
                margin-top: 10px;
                width: 608px;
            }
        }
    }
</style>
